import $ from 'jquery';

const settings = {
    oAuthUrl: 'https://identity.sunway.nl/core/connect/token',
    oAuth: {
        "grant_type":"password",
        "username":"foursites",
        "password":"foursites",
        "scope":"configuratorapi",
        "client_id":"directconnect",
        "client_secret":"secret"
    },
    serviceUrl: 'https://configurator.sunway.nl/api/v1.0/Configurator/',
    serviceUrlGET: 'start/{PID}',
    serviceUrlSET: 'setvalue',
    contentProviders: {
        auth: {
            api_key: 'YouShallNotPass'
        }
    }
};

export default {
    settings,
    getOAthToken() {
        return $.ajax({
            type: "POST",
            crossDomain: true,
            data: settings.oAuth,
            dataType: 'json',
            url: settings.oAuthUrl,
            success: function (result) {
                // console.log('success', result);
            },
            error: function(e) {
                console.log('Could not get token', e);
            }
        });
    },
    getProductData(url, method, oAuthToken) {
        return $.ajax(url, {
            crossDomain: true,
            dataType: 'json',
            method: method || 'GET',
            headers: {
                Authorization: 'Bearer ' + oAuthToken
            },
            xhrFields: {
                withCredentials: true
            }
        });
    },
    selectProduct(productId, oAuthToken) {
        const url = settings.serviceUrl + settings.serviceUrlGET.replace('{PID}', productId);

        return this.getProductData(url, 'GET', oAuthToken)
            .done(function(data) {
                // console.log(data);
                // updateData(data);
            })
            .fail(function(data) {
                // console.log('error loading data');
            });
    },
    getContentProviderData(url) {
        return $.ajax(url, {
            crossDomain: true,
            method: 'GET',
            data: settings.contentProviders.auth,
            success: function(response) {
                // resolve(response);
            },
            error: function() {
                // resolve('');
            }
        });
    },
    getInitialData(url) {
        return $.getJSON(url);
    },
    sendMail(data, mailUrl) {
        const url = mailUrl;
        return $.ajax(url, {
            method: 'post',
            data: data
        });
    }
};
